import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';

export interface CourierIntegration {
  id: number;
  name: string;
  courier_id: number;
  is_active: boolean;
}

interface CourierIntegrationsResponse {
  data: CourierIntegration[];
}

export const useCourierIntegrations = () => {
  const httpClient = createHttpClient(apiClientWH);

  const fetchCourierIntegrations = async (): Promise<CourierIntegration[]> => {
    const response = await httpClient.get<CourierIntegrationsResponse | CourierIntegration[]>(
      '/couriers/integrations'
    );

    const list = Array.isArray(response) ? response : (response.data ?? []);
    return list;
  };

  return useQuery({
    queryKey: ['courier-integrations'],
    queryFn: fetchCourierIntegrations,
    staleTime: 5 * 60 * 1000,
  });
};
